import { Component, Fragment, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  mensagem: string;
  aoFechar: () => void;
  prefixo?: string;
}

interface State {
  erro: boolean;
  tentativa: number;
}

// Rede de proteção: se qualquer coisa dentro quebrar durante o render, mostra
// uma mensagem clara com "Tentar de novo" e "Fechar" em vez de tela em branco.
export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { erro: false, tentativa: 0 };
  }

  static getDerivedStateFromError(): Partial<State> {
    return { erro: true };
  }

  componentDidCatch(error: unknown) {
    // eslint-disable-next-line no-console
    console.error(this.props.prefixo ?? '[Erro]', error);
  }

  tentarDeNovo = () => {
    this.setState((s) => ({ erro: false, tentativa: s.tentativa + 1 }));
  };

  render() {
    if (this.state.erro) {
      return (
        <div className="py-6 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-danger-50 text-danger-600">
            <i className="ri-error-warning-line text-2xl" />
          </span>
          <p className="mt-4 text-[15px] font-medium text-foreground-800">{this.props.mensagem}</p>
          <div className="mt-5 flex gap-3">
            <button
              type="button"
              onClick={this.props.aoFechar}
              className="flex-1 cursor-pointer whitespace-nowrap rounded-2xl border border-secondary-300 bg-white px-4 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-50"
            >
              Fechar
            </button>
            <button
              type="button"
              onClick={this.tentarDeNovo}
              className="flex-1 cursor-pointer whitespace-nowrap rounded-2xl bg-primary-500 px-4 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              Tentar de novo
            </button>
          </div>
        </div>
      );
    }

    // A key força a remontagem dos filhos ao tentar de novo.
    return <Fragment key={this.state.tentativa}>{this.props.children}</Fragment>;
  }
}